export const PAYMENT_TYPES = [
  "Candidate Advance", "Consultancy Fee", "Service Fee", "Processing Fee", "Registration Fee",
  "PCC Income", "Passport Income", "Documentation Income", "Visa Processing Income",
  "Medical Assistance Income", "Ticket/Travel Assistance Income", "Other Income",
];

export const PAYMENT_MODES = ["Cash", "UPI", "Bank Transfer", "NEFT", "RTGS", "IMPS", "Cheque", "Card", "Other"];

export const EXPENSE_PURPOSES = ["Advance", "Visa Fees", "Flight Ticket Payment", "Documentation", "Medical", "PCC / Police Clearance", "Passport", "Agency Commission", "Processing Fee", "Ticket/Travel", "Other"];

export const CANDIDATE_STATUSES = ["New", "Active", "Processing", "Selected", "Visa Processing", "Completed", "On Hold", "Cancelled", "Refunded"];

export const PAYEE_TYPES = ["Agency", "Vendor", "Employee", "Staff", "Consultant", "Landlord", "Service Provider", "Other"];

export const ACCOUNT_TYPES = ["Cash", "Bank", "UPI", "Petty Cash", "Credit Card", "Other"];

export const ROLES = [
  { value: "super_admin", label: "Super Admin" },
  { value: "admin", label: "Admin" },
  { value: "accountant", label: "Accountant" },
  { value: "data_entry", label: "Data Entry Operator" },
  { value: "viewer", label: "Viewer" },
];

export const TXN_TYPE_META = {
  income: { label: "Income", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  candidate_advance: { label: "Candidate Advance", cls: "bg-purple-50 text-purple-700 border-purple-200" },
  expense: { label: "Expense", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  payee_bill: { label: "Agency Bill (Payable)", cls: "bg-orange-50 text-orange-700 border-orange-200" },
  advance_paid: { label: "Advance Paid", cls: "bg-rose-50 text-rose-700 border-rose-200" },
  advance_adjustment: { label: "Advance Adjustment", cls: "bg-teal-50 text-teal-700 border-teal-200" },
  income_recognition: { label: "Income Recognition", cls: "bg-indigo-50 text-indigo-700 border-indigo-200" },
  transfer: { label: "Transfer", cls: "bg-slate-100 text-slate-700 border-slate-200" },
  refund: { label: "Refund", cls: "bg-red-50 text-red-700 border-red-200" },
  opening_balance: { label: "Opening Balance", cls: "bg-gray-100 text-gray-700 border-gray-200" },
};

export const DATE_RANGES = [
  { key: "today", label: "Today" },
  { key: "yesterday", label: "Yesterday" },
  { key: "this_week", label: "This Week" },
  { key: "last_week", label: "Last Week" },
  { key: "this_month", label: "This Month" },
  { key: "last_month", label: "Last Month" },
  { key: "fy", label: "This FY" },
  { key: "custom", label: "Custom" },
];
